import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ALERT_ERRORS, BNPL_VALIDATIONS } from 'src/app/core/constants/Errors';
import { DOC_TYPES } from 'src/app/core/constants/FormLists';
import { ALERT_ICON_CONSTANTS, BUYER_INFORMATION, FLAGS_NAME, GENERAL_CONSTANTS, POP_UP_EXTERNAL_RESPONSES } from 'src/app/core/constants/General-constants';
import { Payment, Transaction } from 'src/app/models';
import { RequestBnpl } from 'src/app/models/request-bnpl';
import { ResponseBnpl } from 'src/app/models/response.bnpl';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { environment } from 'src/environments/environment';
import { BnplBancolombiaService } from '../../services/bnpl-bancolombia.service';
import { BNPL_CONSTANTS } from './constants';
import { finalize } from 'rxjs/operators';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { SweetAlertIcon } from 'sweetalert2';
import { openAndMonitorWindow } from 'src/app/shared/helps/popups.helpers';
import { PopupExternalResponse } from 'src/app/models/popup-external-response.model';
interface buyerInformationData {
  clientId: string,
  redirectUrl: string
}
@Component({
  selector: 'app-bancolombia-bnpl',
  templateUrl: './bancolombia-bnpl.component.html',
  styleUrls: ['./bancolombia-bnpl.component.scss']
})
export class BancolombiaComponent implements OnInit {

  @Input() information: Payment;
  @Input() transaction: Transaction;
  @Output() BNPL = new EventEmitter();

  form: FormGroup;
  template: string;
  urlReturnMerchant: string;
  orderID: string;
  token: string;
  infoMessage = 'bancolombia-Bnpl-redirect';
  customMessageBtn = 'volver';
  dynamicOnboardingUrl = '';
  errorsMessages = BNPL_VALIDATIONS;
  fieldsLength = BNPL_CONSTANTS.FIELDS_LENGTH;
  patternValidations = GENERAL_CONSTANTS.PATTERN;
  phonePrefix = GENERAL_CONSTANTS.PHONE_PREFIX_COLOMBIA;
  buyerInfoResponse = BUYER_INFORMATION.RESPONSE_CODES;
  regexToValidateName = /^\s+|\s+$/gm;
  loading = false;
  showForm = true;
  validateUserBnpl = true;
  listOfDocuments = [];
  buyerInformationData: buyerInformationData;
  enableBnplPopUp = false;
  buyerInformationRequestBody: RequestBnpl;
  openPopupFFparam = '';
  isValidReturnBtn = true;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly tokenService: TokenServiceService,
    private readonly authService: AuthService,
    private readonly alertService: AlertService,
    private readonly bnplService: BnplBancolombiaService,
    private featureFlagService: PayvalidaFeatureFlagService,
  ) {
    this.form = this.formBuilder.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.fieldsLength.EMAIL.MAX_LENGTH),
        Validators.minLength(this.fieldsLength.EMAIL.MIN_LENGTH),
        Validators.pattern(this.patternValidations.EMAIL_VALIDATOR)
      ])],
      cellPhone: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.fieldsLength.PHONE.MAX_LENGTH),
        Validators.minLength(this.fieldsLength.PHONE.MIN_LENGTH),
        Validators.pattern(this.patternValidations.ONLY_NUMBER),
      ])],
      name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.fieldsLength.NAME.MAX_LENGTH),
        Validators.pattern(this.patternValidations.ONLY_STRING_WHITHOUT_SPACES),
      ])],
      lastName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.fieldsLength.LAST_NAME.MAX_LENGTH),
        Validators.pattern(this.patternValidations.ONLY_STRING_WHITHOUT_SPACES)
      ])],
      di: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.fieldsLength.DI.MAX_LENGTH),
        Validators.minLength(this.fieldsLength.DI.MIN_LENGTH),
        Validators.pattern(this.patternValidations.ONLY_NUMBER),
      ])],
      typeDI: ['',
        Validators.compose([
          Validators.required,
          Validators.maxLength(this.fieldsLength.TYPE_DI.MAX_LENGTH)
        ])
      ],
      phoneCode: [{
        value: this.phonePrefix,
        disabled: true
      },
      Validators.compose([
        Validators.required,
        Validators.maxLength(this.fieldsLength.PHONE_CODE.MAX_LENGTH)
      ])
      ]
    });
    const docTypesObjectKeys = Object.keys(DOC_TYPES);
    for (let prop of docTypesObjectKeys) {
      this.listOfDocuments.push(DOC_TYPES[prop]);
    }
  }

  ngOnInit() {
    this.loading = true;
    this.onActivate();
    this.template = this.information.template;
    this.orderID = this.authService.getOrderID();
    this.transaction = this.tokenService.getAndDecodeToken();
    if (Number(this.transaction.ORDER_AMOUT) < environment.minimum_value_bnpl || Number(this.transaction.ORDER_AMOUT) > environment.maximum_value_bnpl) {
      this.validateUserBnpl = false;
      this.loading = false;
      return;
    }

    this.openPopupFFparam = Object.values(GENERAL_CONSTANTS.TEST_MERCHANTS).includes(this.transaction.MERCHANT_ID) ? this.transaction.MERCHANT_ID : `${this.transaction.ORDER_CODE}`;

    this.patchValueForm(this.transaction);
    this.token = this.tokenService.getToken();
    this.validateInfoRedirect(this.transaction);
  }
  /**
   * @description {changeMethod} Function to switch to view of payment methods
   */
  changeMethod() {
    let orderInfo = this.authService.getOrderInfo().OrderID;
    if (this.transaction.ORDER_METHOD) {
      let url = this.authService.buildReturnUrl(this.transaction.MERCHANT_URL_RETURN, orderInfo, this.token);
      window.location.href = url;
      return;
    };
    this.authService.goBackSource.next(true);
  }

  /**
   * @description {onActivate}
   */
  onActivate() {
    window.scroll(0, 0);
  }

  /**
   *  @description {validateData} Function to validate form data
   */
  validateData() {
    this.loading = true;
    let phoneCode: string = this.form.get('phoneCode').value;
    if (this.form.valid) {
      let requestBody: RequestBnpl = {
        token: this.token,
        data: {
          name: this.form.get('name').value,
          lastName: this.form.get('lastName').value,
          documentType: this.form.get('typeDI').value,
          documentNumber: this.form.get('di').value,
          email: this.form.get('email').value,
          phoneCode: phoneCode.replace('+', ''),
          phoneNumber: this.form.get('cellPhone').value
        }
      }
      this.bnplService.buyerInformation(requestBody).subscribe({
        next: (response: ResponseBnpl) => {
          if (response.CODE === GENERAL_CONSTANTS.OK_RESPONSE_CODE) {
            this.buyerInformationData = { clientId: response.DATA.clientId, redirectUrl: response.DATA.redirectUrl };

            if(this.enableBnplPopUp) {
              this.buildbuyerinfoResponse(response);
              this.loading = false;
              
              return;
            }

            this.buildNotification(response.CODE, response.DESC);
            this.loading = false;
            
            return;
          }
          this.loading = false;
          this.alertService.showAlertProblem();
        }, error: (_) => {
          this.loading = false;
          this.alertService.showAlertProblem();
        }
      });
    }
  }

  /**
   * 
   * @description: {buildNotification} Function to build user notification
   * @param responseBody
  */
  buildNotification(...responseBody) {
    let [code, description] = responseBody;
    if (code !== GENERAL_CONSTANTS.OK_RESPONSE_CODE) {
      this.alertService.showAlert(description, 'warning');
    } else {
      let urlParams = `client_id=${this.buyerInformationData.clientId}&redirect_uri=${this.buyerInformationData.redirectUrl}`;
      window.location.href = `${environment.redirect_bnpl}?token=${this.token}&${urlParams}`;
    }
  }

  /**
   * 
   * @description {patchValueForm} Function to preload transaction information
   * @param transaction 
  */
  patchValueForm(transaction: Transaction) {
    let orderInfo = this.authService.getOrderInfo();
    if (transaction.USER_NAME !== "") {
      let { convertedNames, convertedLastNames } = this.splitFullName(transaction.USER_NAME);
      this.form.get('name').patchValue(convertedNames);
      this.form.get('lastName').patchValue(convertedLastNames);
    }
    this.form.get('di').patchValue(transaction.USER_DI ? transaction.USER_DI : '');
    this.form.get('typeDI').patchValue(transaction.USER_TYPE_DI ? transaction.USER_TYPE_DI : '');
    this.form.get('email').patchValue(orderInfo.OrderEmail ? orderInfo.OrderEmail.replace(this.regexToValidateName, "") : '');
  }
  /**
   * 
   * @description {validateDataName} Function that performs the separation and validation of the names and surnames of the user 
   * that creates the payment order, each position of the array is validated and it is verified that it contains spaces 
   * in order to separate names from surnames.
   * @param datName 
   * @returns convert user's first and lastname 
  */
  splitFullName(fullUserName: string) {
    let positionIndex = 0;
    let n = 0;
    let positionArray = [];
    let index = 0;
    let i = 0;
    let convertedNames = fullUserName;
    let convertedLastNames = "";
    positionIndex = fullUserName.indexOf(" ");
    try {
      while (positionIndex !== -1) {
        positionArray[i] = positionIndex;
        n = positionIndex;
        i++;
        positionIndex = fullUserName.indexOf(" ", n + 1)
      }
      if (positionArray.length > 0) {
        index = positionArray[0];
        if (positionArray.length > 1) {
          index = positionArray[positionArray.length - 2]
        }
        convertedNames = fullUserName.slice(0, index);
        convertedLastNames = fullUserName.slice(index);
      }
      convertedNames = convertedNames.replace(this.regexToValidateName, '');
      convertedLastNames = convertedLastNames.replace(this.regexToValidateName, '');
      return { convertedNames, convertedLastNames }
    } catch {
      this.alertService.showAlertProblem();
      this.loading = false;
    }
  }

  /**
   * 
   * @param transaction {validateInfoRedirect} Function to redirect onboarding BNPL without form
  */
  validateInfoRedirect(transaction: Transaction) {
    let name = '';
    let lastName = '';
    let orderInfo = this.authService.getOrderInfo();
    const inforOrderPayvalida = this.bnplService.returnRequestPayvalida();

    if (transaction.USER_NAME) {
      let { convertedNames, convertedLastNames } = this.splitFullName(transaction.USER_NAME);
      name = convertedNames;
      lastName = convertedLastNames.replace(/^\s+|\s+$/gm, '');
    }

    let requestBody: RequestBnpl = {
      token: this.token,
      data: {
        name: name ? name : inforOrderPayvalida.name,
        lastName: lastName ? lastName : inforOrderPayvalida.lastName,
        documentType: transaction.USER_TYPE_DI ? transaction.USER_TYPE_DI : inforOrderPayvalida.documentType,
        documentNumber: transaction.USER_DI ? transaction.USER_DI : inforOrderPayvalida.documentNumber,
        phoneCode: GENERAL_CONSTANTS.PHONE_PREFIX_COLOMBIA.replace("+", ""),
        email: orderInfo.OrderEmail ? orderInfo.OrderEmail.replace(this.regexToValidateName, "") : inforOrderPayvalida.email,
        phoneNumber: environment.payvalidaPhone.toString()
      }
    }

    this.buyerInformationRequestBody = requestBody;

    this.featureFlagService.getFeatureFlagValue(this.openPopupFFparam, FLAGS_NAME.ENABLE_BNPL_POPUP, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM).subscribe(async (response: boolean) => {
      this.enableBnplPopUp = response;

      return this.validateBnplFlow();
    });
  }
  /**
   * @description: Function to validate the following BNPL flow
  */
  validateBnplFlow() {
    this.showForm = false;

    try {
      if (this.buyerInformationRequestBody) {

        this.bnplService.buyerInformation(this.buyerInformationRequestBody).pipe(
          finalize(() => this.loading = false)
        ).subscribe({
          next: async (response: ResponseBnpl) => {
            this.buildbuyerinfoResponse(response);
          }, error: () => {
            this.infoMessage = 'alert-error-msg';
            this.alertService.showAlertProblem();
          }
        });

      }
    } catch (_) {
      this.loading = false;
      this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.ERROR as SweetAlertIcon);
    }
  }

  /**
   * @description {buildbuyerinfoResponse} Function to build the response from the buyerInformation service
   * @param response 
  */
  buildbuyerinfoResponse(response: ResponseBnpl) {
    switch (response.CODE) {
      case this.buyerInfoResponse.OK_RESPONSE_CODE:
        this.returnOnboardingurl(response);
        break;
      case this.buyerInfoResponse.PROCESS_PAYMENT:
        this.infoMessage = 'bnpl-Buyer-Info-Process-Payment';
        break;
      default:
        this.alertService.showAlertProblem();
        this.infoMessage = 'alert-error-msg';
        break;
    }
  }
  
  /**
   * 
   * @description {returnOnboardingurl} Function to build bnp url depends to FF
   * @returns
  */
  returnOnboardingurl(responseBalance: any) {
    this.dynamicOnboardingUrl = '';

    let baseUrl = new URL(`${environment.redirect_bnpl}?token=${this.token}`);

    baseUrl.searchParams.append('signAuthentication', responseBalance.DATA.signAuthentication);
    baseUrl.searchParams.append('userAuthentication', responseBalance.DATA.userAuthentication);

    this.dynamicOnboardingUrl = baseUrl.href;

    if (this.validateUserBnpl) {
      if (this.enableBnplPopUp) {
        this.isValidReturnBtn = false;

        openAndMonitorWindow(this.dynamicOnboardingUrl, GENERAL_CONSTANTS.BNPL_STRING).then((response: PopupExternalResponse) => {

          switch (response.code) {
            case ALERT_ERRORS.PROCESS_WAS_NOT_FINISHED:
              this.alertService.showAlert(response.code, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
              this.showForm = true;
              this.loading = false;
              this.isValidReturnBtn = true;

              break;

            case POP_UP_EXTERNAL_RESPONSES.BNPL_COMPLETED:
              this.showForm = true;
              this.loading = true;
              this.isValidReturnBtn = true;

              window.location.href = response.returnUrl;

              break;

            default:
              this.alertService.showAlert(ALERT_ERRORS.POP_UP_BLOCKED, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
              this.showForm = true;
              this.loading = false;
              this.isValidReturnBtn = true;

              break;
          }
        });

        return;
      }

      window.location.href = this.dynamicOnboardingUrl;
    }
  }
}
